import React from 'react';

import PropTypes from 'prop-types';

import clsx from 'clsx';

import styles from './TileColoredWithChild.module.css';
import { PromoButton } from '../promo-button/PromoButton';
import { PromoDangerouslyHtml } from '../promo-dangerously-html/PromoDangerouslyHtml';
import { PromoText } from '../promo-text/PromoText';

export const TileColoredWithChild = ({ bgColor = 'aubergine01', ...props }) => {
    const containerClass = clsx(styles.tileContainer, `bg${bgColor.charAt(0).toUpperCase() + bgColor.slice(1)}`);
    return (
        <div className={containerClass}>
            {props.title && (
                <div className={styles.title}>
                    <PromoText color={'white'} tag="div" variant="h1" textAlign={'center'}>
                        {props.title}
                    </PromoText>
                </div>
            )}
            {props.subtitle && <PromoDangerouslyHtml color={'white'} dangerouslyHtml={props.subtitle} tag="div" variant={'subheader'} textAlign={'center'} />}
            {props.children}
            {props.btnTitle && (
                <div className={styles.buttonContainer}>
                    <PromoButton caption={props.btnTitle} disabled={props.disabledBtn} variant="primary" isInverted onClick={props.onButtonClick} />
                </div>
            )}
            {props.note && (
                <div className={styles.note}>
                    <PromoText color={'white'} tag="div" textAlign={'center'}>
                        {props.note}
                    </PromoText>
                </div>
            )}
        </div>
    );
};

TileColoredWithChild.propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    btnTitle: PropTypes.string,
    onButtonClick: PropTypes.func,
    disabledBtn: PropTypes.bool,
    note: PropTypes.string,
};
